module.exports = __webpack_public_path__ + "media/boschautoparts/logo_ponce_01-e155a1cf.png";